export enum LocalStorageKeyEnum {
    CustomPortalName = 'custom-portal-name',
    ShowIpdSubmitConfirmation = 'show-ipd-submit-confirmation'
}
